import request from '../https'

class ShowerRequest {
    //智能花洒列表
    getSmartShowerList(params){
        return request({
            url: 'safety/smartshower/list',
            method: 'post',
            params
        })
    }
    //获取是否使用小龙潜行花洒
    isLongoorSmartShower(params){
        return request({
            url: 'safety/smartshower/isLongoorSmartShower',
            method: 'get',
            params
        })
    }
    //推送
    pushNxinShower(params){
        return request({
            url: 'safety/smartshower/pushNxinShower',
            method: 'get',
            params
        })
    }
    //新增智能花洒
    addSmartShowerList(params){
        return request({
            url: 'safety/smartshower/add',
            method: 'post',
            params
        })
    }
    //修改智能花洒
    updateSmartShowerMeter(params){
        return request({
            url: 'safety/smartshower/update',
            method: 'post',
            params
        })
    }
    //删除智能花洒
    deleteSmartShowerMeter(params){
        return request({
            url: 'safety/smartshower/delete',
            method: 'post',
            params
        })
    }
    //查询智能花洒猪场参数设置
    getSmartShowerFarm(params){
        return request({
            url: 'safety/smartshowerFarm/info',
            method: 'post',
            params
        })
    }
    //编辑智能花洒猪场参数设置
    updateSmartShowerFarm(params){
        return request({
            url: 'safety/smartshowerFarm/update',
            method: 'post',
            params
        })
    }
    //编辑智能花洒猪场参数设置
    getLogList(params){
        return request({
            url: 'safety/peopleSmartshower/logList',
            method: 'post',
            params
        })
    }
    //获取智能花洒人员淋浴记录列表接口
    getSmartShower(params){
        return request({
            url: 'safety/smartshower/record',
            method: 'post',
            params
        })
    }
    //推送
    pushAgain(params){
        return request({
            url: 'safety/peopleSmartshower/pushAgain',
            method: 'post',
            data:params
        })
    }
}

export default ShowerRequest
